import { Ng2StateDeclaration } from '@uirouter/angular';

export const entityState: Ng2StateDeclaration = {
  name: 'app.entity',
  abstract: true,
  url: '',
};
